<template>
  <div class="right-list">
    <rightTop></rightTop>
    <rightCenter></rightCenter>
    <rightBottom></rightBottom>
  </div>
</template>
<script>
import wgEchart from "@/components/wgEchart/wgEchart.vue";
import rightTop from "@/pages/patrolScreenMini/components/right/right-top.vue";
import rightCenter from "@/pages/patrolScreenMini/components/right/right-center.vue";
import rightBottom from "@/pages/patrolScreenMini/components/right/right-bottom.vue";
export default {
  name: "index",
  components: {
    wgEchart,
    rightTop,
    rightCenter,
    rightBottom
  },
  data() {
    return {
      optionsOne: {
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "5%",
          left: "center",
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 1048, name: "Search Engine" },
              { value: 735, name: "Direct" },
              { value: 580, name: "Email" },
              { value: 484, name: "Union Ads" },
              { value: 300, name: "Video Ads" },
            ],
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="less">
.right-list {
  width: 727px;
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreenMini/components/right/index.vue